/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getMessaging } from 'firebase/messaging'
// import { getFirestore } from "firebase/firestore";
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import moment from 'moment'
import { VBPopover } from 'bootstrap-vue'
import BootstrapVue from 'bootstrap-vue'
import Popover from 'vue-js-popover'
import VCalendar from 'v-calendar';
import VueFriendlyIframe from 'vue-friendly-iframe';
import axios from 'axios';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueHtmlToPaper from 'vue-html-to-paper';
import DataTable from "@andresouzaabreu/vue-data-table";
import fullCalendar from 'vue-fullcalendar'

Vue.component("data-table", DataTable);
Vue.component('full-calendar', fullCalendar)

import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);

import { LicenseManager } from 'ag-grid-enterprise'
LicenseManager.setLicenseKey(process.env.VUE_APP_AGGRID)

axios.defaults.baseURL = process.env.BASE_URL;

Vue.config.productionTip = false
let app = ''

const HTMLtoPaperOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}
/**
 * Package to print html tags
 */
Vue.use(VueHtmlToPaper, HTMLtoPaperOptions);

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment.unix(value).format('YYYY/MM/DD')
  }
})
Vue.use(BootstrapVue)
Vue.use(VCalendar)
Vue.use(VueFriendlyIframe);
Vue.use(VueSweetalert2);
Vue.directive('b-popover', VBPopover)
Vue.component('vue-multiselect', window.VueMultiselect.default)
Vue.component('flat-pickr', window.VueFlatpickr);
Vue.prototype.heap = window.heap;

import posthogPlugin from "./plugins/posthog";
Vue.use(posthogPlugin);
import posthog from "posthog-js";

const firebaseConfig = {
  apiKey: "AIzaSyBPznnEnEVHt0tfFKxSXF8DcXj2HdEAMqY",
  authDomain: "canplast-mx.firebaseapp.com",
  databaseURL: "https://canplast-mx.firebaseio.com",
  projectId: "canplast-mx",
  storageBucket: "canplast-mx.appspot.com",
  messagingSenderId: "862464859401",
  appId: "1:862464859401:web:19ad54f3ebc7a645ad07d8",
  measurementId: "G-5MW0BHRGJS"
};

// Initialize Firebase
const appFirebase = initializeApp(firebaseConfig);
const auth = getAuth(appFirebase);
const messaging = getMessaging(appFirebase)
// const db = getFirestore(appFirebase);

onAuthStateChanged(auth, (user) => {
  if (user && user.email) {
    posthog.identify(
      user.email,
      { id: user.uid, email: user.email, name: user.displayName }
    );
  } else {
    posthog.reset();
  }

  if (!app) {
    app = Vue.use(ArgonDashboard, Popover);
    new Vue({
      router,
      render: h => h(App)
    }).$mount('#app');
  }
});

Vue.prototype.$messaging = messaging
